import React from 'react';
import ResetPassword from '../../forms/ResetPassword';
import centredForm from '../components/centredForm';
import { Trans } from 'react-i18next';

export default centredForm(
  ResetPassword,
  <Trans>resetPasswordNewPasswordTitle</Trans>,
  350
);



// WEBPACK FOOTER //
// ./src/view/scenes/ResetPassword/index.js